/**
 * Warn about past workshop dates left in the cart.
 * Checkout is not blocked: Remove deletes the lines, Keep continues to pay.
 */
(function (global) {
  'use strict';

  if (global.WorkshopCartPastEvents) return;

  var DIALOG_ID = 'amc-past-event-dialog';
  var DEFAULT_TZ = 'America/Los_Angeles';
  var promptedOnOpen = false;
  var dialogPromise = null;
  var cachedHasPast = false;

  function isIanaTimeZone(value) {
    return /^[A-Za-z_]+(?:\/[A-Za-z0-9_+\-]+)+$/.test(String(value || '').trim());
  }

  function shopTimeZone() {
    var candidates = [global.__AMC_SHOP_TZ, global.Shopify && global.Shopify.timezone, DEFAULT_TZ];
    for (var i = 0; i < candidates.length; i++) {
      var tz = String(candidates[i] || '').trim();
      if (isIanaTimeZone(tz)) return tz;
    }
    return DEFAULT_TZ;
  }

  function shopNowParts() {
    var parts = { year: '1970', month: '01', day: '01', hour: '00', minute: '00', second: '00' };
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: shopTimeZone(),
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .forEach(function (part) {
          if (part.type !== 'literal') parts[part.type] = part.value;
        });
    } catch (_) {
      var d = new Date();
      parts.year = String(d.getUTCFullYear());
      parts.month = String(d.getUTCMonth() + 1).padStart(2, '0');
      parts.day = String(d.getUTCDate()).padStart(2, '0');
      parts.hour = String(d.getUTCHours()).padStart(2, '0');
      parts.minute = String(d.getUTCMinutes()).padStart(2, '0');
      parts.second = String(d.getUTCSeconds()).padStart(2, '0');
    }
    return {
      dateKey: parts.year + '-' + parts.month + '-' + parts.day,
      seconds: Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second),
    };
  }

  function todayKey() {
    return shopNowParts().dateKey;
  }

  function prop(properties, key) {
    if (!properties) return '';
    if (!Array.isArray(properties)) {
      return properties[key] != null ? String(properties[key]).trim() : '';
    }
    for (var i = 0; i < properties.length; i++) {
      var row = properties[i];
      if (!row) continue;
      var k = row[0] != null ? row[0] : row.name;
      var v = row[1] != null ? row[1] : row.value;
      if (k === key && v != null) return String(v).trim();
    }
    return '';
  }

  function isWorkshopItem(item) {
    if (!item) return false;
    if (prop(item.properties, '_workshop_addon') === 'true') return false;
    return prop(item.properties, '_workshop') === 'true' || prop(item.properties, '_is_workshop') === '1';
  }

  function dateKeyFromValue(value) {
    var s = String(value || '').trim();
    if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    return '';
  }

  function wallClockFromSchema(value) {
    var s = String(value || '').trim();
    var match = s.match(/^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!match) return null;
    return {
      dateKey: match[1],
      seconds:
        match[2] != null
          ? Number(match[2]) * 3600 + Number(match[3]) * 60 + Number(match[4] || 0)
          : null,
    };
  }

  function isEndedStatus(status, displayStatus) {
    var st = String(status || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
    var ds = String(displayStatus || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
    return st === 'completed' || st === 'cancelled' || ds === 'ended' || ds === 'hidden';
  }

  function isPastFromFields(dateKey, schemaStart, schemaEnd, status, displayStatus) {
    if (isEndedStatus(status, displayStatus)) return true;
    var now = shopNowParts();
    var startKey = dateKeyFromValue(dateKey) || dateKeyFromValue(schemaStart);
    var end = wallClockFromSchema(schemaEnd);
    if (end && end.seconds != null) {
      if (end.dateKey < now.dateKey) return true;
      if (end.dateKey === now.dateKey && end.seconds < now.seconds) return true;
      return false;
    }
    if (startKey && startKey < now.dateKey) return true;
    if (end && end.dateKey && end.dateKey < now.dateKey) return true;
    return false;
  }

  function isPastWorkshopItem(item) {
    if (!isWorkshopItem(item)) return false;
    var properties = item.properties;
    return isPastFromFields(
      prop(properties, '_date_key'),
      prop(properties, '_schema_start'),
      prop(properties, '_schema_end'),
      prop(properties, '_event_status'),
      prop(properties, '_display_status')
    );
  }

  function isPastSlot(slot) {
    if (!slot) return false;
    return isPastFromFields(
      slot.date_key,
      slot.schema_start,
      slot.schema_end,
      slot.status || slot.event_status,
      slot.display_status
    );
  }

  function lineLabel(item) {
    var title = String((item && item.product_title) || (item && item.title) || 'Workshop').trim();
    var when =
      prop(item.properties, '_session_label') ||
      prop(item.properties, '_display_datetime') ||
      dateKeyFromValue(prop(item.properties, '_date_key')) ||
      '';
    return when ? title + ' · ' + when : title;
  }

  function findPastLines(cart) {
    var lines = [];
    if (!cart || !Array.isArray(cart.items)) return lines;
    cart.items.forEach(function (item) {
      if (!item || !isPastWorkshopItem(item)) return;
      lines.push({
        key: item.key,
        quantity: item.quantity,
        title: lineLabel(item),
      });
    });
    return lines;
  }

  function cartRoot() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }

  function isCartPage() {
    var path = (global.location && global.location.pathname) || '';
    return /(^|\/)cart\/?$/.test(path);
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function sectionsPayload() {
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        return global.Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (_) {}
    return [];
  }

  function refreshCartUi(parsed) {
    try {
      var helper = global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper');
      if (parsed && parsed.sections && helper && typeof helper.reRenderSections === 'function') {
        helper.reRenderSections(parsed.sections);
        return;
      }
      var mini = global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart');
      if (mini && typeof mini.reLoad === 'function') {
        mini.needReload = true;
        mini.reLoad();
      }
    } catch (_) {}
  }

  function removePastLines(lines) {
    var updates = {};
    (lines || []).forEach(function (line) {
      if (line && line.key) updates[line.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(null);
    var body = { updates: updates };
    var sections = sectionsPayload();
    if (sections.length) body.sections = sections;
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart-update-failed');
      return res.json();
    }).then(function (parsed) {
      refreshCartUi(parsed);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      return parsed;
    });
  }

  function closeDialog() {
    var el = global.document.getElementById(DIALOG_ID);
    if (!el) return;
    try {
      if (typeof el.close === 'function') el.close();
    } catch (_) {}
    if (el.parentNode) el.parentNode.removeChild(el);
    var style = global.document.getElementById(DIALOG_ID + '-style');
    if (style && style.parentNode) style.parentNode.removeChild(style);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showDialog(lines, mode) {
    if (dialogPromise) return dialogPromise;
    dialogPromise = new Promise(function (resolve) {
      var many = lines.length > 1;
      var style = global.document.createElement('style');
      style.id = DIALOG_ID + '-style';
      style.textContent =
        '#' +
        DIALOG_ID +
        '{border:0;padding:0;margin:0;max-width:none;max-height:none;width:100vw;height:100vh;background:transparent;}' +
        '#' +
        DIALOG_ID +
        '::backdrop{background:rgba(34,24,18,.45);}';
      global.document.head.appendChild(style);

      var overlay = global.document.createElement('dialog');
      overlay.id = DIALOG_ID;
      overlay.setAttribute('aria-labelledby', DIALOG_ID + '-title');
      overlay.style.cssText =
        'display:flex;align-items:center;justify-content:center;padding:88px 20px 20px;box-sizing:border-box;';

      var list = lines
        .map(function (line) {
          return '<li style="margin:0 0 6px;">' + escapeHtml(line.title) + '</li>';
        })
        .join('');

      overlay.innerHTML =
        '<div data-amc-past-card style="width:min(440px,100%);background:#fff;color:#2b211b;border-radius:16px;padding:22px 22px 18px;box-shadow:0 18px 50px rgba(43,33,27,.22);font-family:inherit;">' +
        '<h2 id="' +
        DIALOG_ID +
        '-title" style="margin:0 0 10px;font-size:20px;line-height:1.3;font-weight:650;">This workshop date has passed</h2>' +
        '<p style="margin:0 0 12px;font-size:15px;line-height:1.5;">' +
        (many
          ? 'These workshops in your cart have already passed. Do you want to remove them?'
          : 'This workshop date has passed. Do you want to remove it from your cart?') +
        '</p>' +
        '<ul style="margin:0 0 18px;padding-left:18px;font-size:14px;line-height:1.45;color:#5b4c43;">' +
        list +
        '</ul>' +
        '<div style="display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap;">' +
        '<button type="button" data-amc-past="remove" style="min-height:42px;padding:0 14px;border-radius:999px;border:1px solid #c9b8ab;background:#fff;color:#2b211b;cursor:pointer;font-size:14px;line-height:1.2;appearance:none;-webkit-appearance:none;">Remove</button>' +
        '<button type="button" data-amc-past="keep" style="min-height:42px;padding:0 16px;border-radius:999px;border:0;background:#3e2b21;color:#fff;cursor:pointer;font-size:14px;line-height:1.2;appearance:none;-webkit-appearance:none;">' +
        (mode === 'checkout' ? 'Continue to checkout' : 'Keep in cart') +
        '</button>' +
        '</div>' +
        '</div>';

      var settled = false;
      function finish(choice) {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', onKey, true);
        closeDialog();
        dialogPromise = null;
        resolve(choice);
      }

      function onKey(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          finish('keep');
        }
      }

      overlay.addEventListener('cancel', function (e) {
        e.preventDefault();
        finish('keep');
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          finish('keep');
          return;
        }
        var btn = e.target.closest('[data-amc-past]');
        if (!btn) return;
        finish(btn.getAttribute('data-amc-past') === 'remove' ? 'remove' : 'keep');
      });
      document.addEventListener('keydown', onKey, true);
      document.body.appendChild(overlay);
      if (typeof overlay.showModal === 'function') {
        overlay.showModal();
      } else {
        overlay.setAttribute('open', '');
      }
      var primary = overlay.querySelector('[data-amc-past="keep"]');
      if (primary) primary.focus();
    });
    return dialogPromise;
  }

  function setCachedHasPast(next) {
    cachedHasPast = !!next;
  }

  function refreshPastCache() {
    return fetchCart().then(function (cart) {
      setCachedHasPast(findPastLines(cart).length > 0);
      return cart;
    });
  }

  function confirmPastLines(mode) {
    return fetchCart().then(function (cart) {
      if (!cart) return { action: 'unknown', cart: null, lines: [] };
      var lines = findPastLines(cart);
      setCachedHasPast(lines.length > 0);
      if (!lines.length) return { action: 'none', cart: cart, lines: [] };
      return showDialog(lines, mode).then(function (choice) {
        if (choice !== 'remove') {
          return { action: 'keep', cart: cart, lines: lines };
        }
        return removePastLines(lines).then(function (nextCart) {
          var stillPast = findPastLines(nextCart);
          setCachedHasPast(stillPast.length > 0);
          if (stillPast.length) return { action: 'failed', cart: nextCart, lines: stillPast };
          return { action: 'removed', cart: nextCart, lines: lines };
        });
      });
    });
  }

  function confirmBeforeCheckout() {
    return confirmPastLines('checkout')
      .then(function (result) {
        if (result && result.action === 'removed') {
          var remaining = result.cart && typeof result.cart.item_count === 'number' ? result.cart.item_count : 0;
          return remaining > 0;
        }
        return true;
      })
      .catch(function () {
        return true;
      });
  }

  function maybePromptOnCartOpen() {
    if (promptedOnOpen || dialogPromise) return;
    fetchCart().then(function (cart) {
      var lines = findPastLines(cart);
      setCachedHasPast(lines.length > 0);
      if (!lines.length) return;
      promptedOnOpen = true;
      showDialog(lines, 'cart').then(function (choice) {
        if (choice !== 'remove') return;
        return removePastLines(lines)
          .then(function (nextCart) {
            setCachedHasPast(findPastLines(nextCart).length > 0);
          })
          .catch(function () {
            promptedOnOpen = false;
          });
      });
    });
  }

  function watchMiniCart() {
    try {
      if (!global.Alpine || !global.Alpine.store) return false;
      var mini = global.Alpine.store('xMiniCart');
      if (!mini) return false;
      if (mini.__amcPastWatch) return true;
      mini.__amcPastWatch = true;
      if (typeof global.Alpine.effect === 'function') {
        global.Alpine.effect(function () {
          if (mini.open) maybePromptOnCartOpen();
        });
      }
      return true;
    } catch (_) {
      return false;
    }
  }

  function bindCartOpen() {
    document.addEventListener('cart:open', function () {
      maybePromptOnCartOpen();
    });
    document.addEventListener('eurus:cart:items-changed', function () {
      promptedOnOpen = false;
      refreshPastCache();
    });
    document.addEventListener('alpine:init', function () {
      setTimeout(watchMiniCart, 0);
    });
    if (global.Alpine && global.Alpine.store) watchMiniCart();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (watchMiniCart() || tries > 40) clearInterval(timer);
    }, 250);
    if (isCartPage()) maybePromptOnCartOpen();
    refreshPastCache();
  }

  if (global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', bindCartOpen);
  } else {
    bindCartOpen();
  }

  global.WorkshopCartPastEvents = {
    todayKey: todayKey,
    shopTimeZone: shopTimeZone,
    isEndedStatus: isEndedStatus,
    isPastWorkshopItem: isPastWorkshopItem,
    isPastSlot: isPastSlot,
    findPastLines: findPastLines,
    confirmBeforeCheckout: confirmBeforeCheckout,
    confirmPastLines: confirmPastLines,
  };
})(typeof window !== 'undefined' ? window : this);
